<template>
	<h2 class="text-5xl sm:text-6xl text-center font-semibold text-pretty">
		{{ title }}
	</h2>
</template>

<script setup lang="ts">
defineProps({
	title: {
		type: String,
		required: true
	}
})
</script>
